import script from "./StartSetup.vue?vue&type=script&setup=true&lang=ts"
export * from "./StartSetup.vue?vue&type=script&setup=true&lang=ts"

import "./StartSetup.vue?vue&type=style&index=0&id=68031ce0&lang=scss"

const __exports__ = script;

export default __exports__